
import Vue from 'vue';
import { oneOf } from '@customer/utils/helpers';

// When you need to add or remove svg then update iconNames. (vue validates all names written in iconNames.)

// Get svgs from assets/svg/icons/ folder and automatically import them.
// Use when you need to render inline svg. Example: copy svg angle-right.svg to assets/svg/icons folder and then use it <BaseIcon name="angle-right" add-class="U-fill-primary" />.
interface Props {
  name: string;
  addClass: string;
}

const iconNames: string[] = ['angle-left', 'close', 'success'];

export default Vue.extend<Props>({
  functional: true,
  props: {
    name: {
      type: String,
      default: () => '',
      required: true,
      validator(value: string) {
        return oneOf(value, iconNames);
      },
    },
    addClass: {
      type: String,
      default: () => null,
      required: false,
    },
  },
});
